import { getInsightsDiffPct } from "../../lens-insights/math/getInsightsDiffPct";
import { formatSignedPctNumber } from "../../lens-stats/formatters/formatNumbers";

// Do not expose private signup counts through a percentage comparison.
export const lensPlusComparison = (
    current: number | null | undefined,
    prior: number | null | undefined,
    signups = false,
): string | null => {
    if (
        typeof current !== "number" ||
        typeof prior !== "number" ||
        prior <= 0 ||
        !Number.isFinite(current) ||
        !Number.isFinite(prior)
    )
        return null;
    if (signups && ((current > 0 && current < 10) || prior < 10)) return null;
    return formatSignedPctNumber(getInsightsDiffPct(current, prior));
};
